import { OverdueEventProvider } from "@/utils/api-client";
import { ApiClientFactory } from "./clients";

export class OverdueEventProviderFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/project`);
  }

  createOverdueEventProvider(authToken: string): OverdueEventProvider {
    return new OverdueEventProvider(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
